
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/businesses",
      function () {
        return require("private-next-pages/businesses/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/businesses"])
      });
    }
  